import React from 'react';
import ForgetPasswordForm from 'components/authentication/ForgetPasswordForm';
import { titler } from 'helpers/titler';

const ForgetPassword = () => {
  titler('Password dimenticata?');
  return (
    <div className="text-center">
      <h5 className="mb-2">Password dimenticata?</h5>
      <p className="fs-10 text-600 mb-0">
        Inserisci la tua email e ti invieremo un link per resettare la password.
      </p>
      <ForgetPasswordForm />
    </div>
  );
};

export default ForgetPassword;
